var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"discover-container"},[_c('main-empty',{attrs:{"page":"trending","desc":'cccc'},on:{"log":_vm.handleLog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }